import {parseDate, today} from 'common/date';

/**
 * A calendar date (`YYYY-MM-DD`) as list rows show it: "Jul 14" within the
 * current year, "Jul 14, 2025" otherwise. Rows are scanned, not read — the
 * year only earns its width once it stops being the obvious one.
 */
export const formatListDate = (isoDate: string): string => {
  const date = parseDate(isoDate);
  return date.year === today().year
    ? date.toFormat('MMM d')
    : date.toFormat('MMM d, yyyy');
};

/**
 * A calendar date as detail pages show it: always with the year, since a
 * detail page is a record rather than a row in a recent-first list.
 */
export const formatFullDate = (isoDate: string): string =>
  parseDate(isoDate).toFormat('MMM d, yyyy');
